__turbopack_context__.v({
  "close": "search-section-module-scss-module__O_Tu1G__close",
  "isVisible": "search-section-module-scss-module__O_Tu1G__isVisible",
  "search": "search-section-module-scss-module__O_Tu1G__search",
  "tabDrawer": "search-section-module-scss-module__O_Tu1G__tabDrawer",
  "tabWrapper": "search-section-module-scss-module__O_Tu1G__tabWrapper",
  "wrapper": "search-section-module-scss-module__O_Tu1G__wrapper",
});
